import PropTypes from 'prop-types';

import { useTownAssets } from '../../stores';
import {
  Column,
  Row,
} from '../display';
import { PxMap } from '../PxMaps';

function CompanyGovSummary(props) {
  const { company } = props;
  const { assets } = useTownAssets();
  const { translate } = assets;

  const address = company.cstmrRegisteredAddress;
  const latLng = address?.govAddressLatLng;

  return (
    <Column crossStart gap={2} className="w-full">
      <Row gap={2}>
        <span className="font-semibold">{company.cstmrGovLbl}</span>

        {(company.cstmrSignLbl) ? <i>{`(${company.cstmrSignLbl})`}</i> : null}

        {(company.cstmrActivityTypeTxt) ? <i>{` - ${company.cstmrActivityTypeTxt}`}</i> : null}
      </Row>

      <Row gap={6} crossStart>
        {(latLng)
          ? (
              <div className="h-40 w-48">
                <PxMap
                  mapConfig={{}}
                  mapCenter={[latLng.lat, latLng.lng]}
                  hideControls
                  markersArrayRef={{
                    current: [{
                      id: company.cstmrGovLbl,
                      title: company.cstmrGovLbl,
                      type: 'maps',
                      code: 'home',
                      lat: latLng.lat,
                      lng: latLng.lng,
                      anchor: {
                        x: 0.5,
                        y: 1,
                      },
                      zIndex: 1,
                      opacity: 1,
                      heightPx: 40,
                      widthPx: 24,
                      color: 0x4050FF,
                      colorHex: '#4050FF',
                    }],
                  }}
                  markersPending={false}
                />
              </div>
            )
          : null}

        <Column start crossStart>
          {(company.cstmrLegalTypeTxt) ? <Row>{company.cstmrLegalTypeTxt}</Row> : null}
          {(address?.govAddressStreet) ? <Row>{`${address.govAddressStreet},`}</Row> : null}
          {(address)
            ? (
                <Row>
                  {`${address.govAddressZipCode ?? ''} ${address.govAddressCity ?? ''} (${
                    address.govAddressCtry?.toUpperCase() ?? ''})`}
                </Row>
              )
            : null}
          {(address?.govAddressId)
            ? <Row className="text-pxTxtMuted">{`${translate('siret')}: ${address.govAddressId}`}</Row>
            : null}
        </Column>
      </Row>
    </Column>
  );
}

CompanyGovSummary.propTypes = {
  company: PropTypes.shape({
    cstmrGovLbl: PropTypes.string,
    cstmrSignLbl: PropTypes.string,
    cstmrActivityTypeTxt: PropTypes.string,
    cstmrLegalTypeTxt: PropTypes.string,
    cstmrRegisteredAddress: PropTypes.shape({
      govAddressId: PropTypes.string,
      govAddressStreet: PropTypes.string,
      govAddressZipCode: PropTypes.string,
      govAddressCity: PropTypes.string,
      govAddressCtry: PropTypes.string,
      govAddressLatLng: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
      }),
    }),
  }).isRequired,
};

export default CompanyGovSummary;
